var map = {
	"./close.svg": 2496,
	"./default.svg": 1579,
	"./default2.svg": 6611,
	"./defaultImg.svg": 8598,
	"./down.svg": 1955,
	"./icon.svg": 7164,
	"./logo.svg": 6316,
	"./top.svg": 2503,
	"./vip.svg": 3817,
	"./vipIcon.svg": 2180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;